import { EventsCalendar } from '@/modules/events-calendar/types';
import { all_roles } from '@/utils';

const access_roles = {
  [EventsCalendar.Pages.CALENDAR]: all_roles,
};

export default access_roles;
